import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { servicingSeatmapReducer } from './servicing-seatmap.reducer';
import { SERVICING_SEATMAP_STORE_NAME, ServicingSeatmapState } from './servicing-seatmap.state';

/** Token of the ServicingSeatmap reducer */
export const SERVICING_SEATMAP_REDUCER_TOKEN = new InjectionToken<ActionReducer<ServicingSeatmapState, Action>>(
  'Feature ServicingSeatmap Reducer'
);

/** Provide default reducer for ServicingSeatmap store */
export function getDefaultServicingSeatmapReducer() {
  return servicingSeatmapReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(SERVICING_SEATMAP_STORE_NAME, SERVICING_SEATMAP_REDUCER_TOKEN)],
  providers: [{ provide: SERVICING_SEATMAP_REDUCER_TOKEN, useFactory: getDefaultServicingSeatmapReducer }],
})
export class ServicingSeatmapStoreModule {
  public static forRoot<T extends ServicingSeatmapState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<ServicingSeatmapStoreModule> {
    return {
      ngModule: ServicingSeatmapStoreModule,
      providers: [{ provide: SERVICING_SEATMAP_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
